import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-query';
import * as API from 'api';

import { withStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiPaper from '@material-ui/core/Paper';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiTypography from '@material-ui/core/Typography';
import MuiTablePagination from '@material-ui/core/TablePagination';

import Row from './release-table-row';

const Groups = API.Groups();

const styles = () => ({
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  actionRow: {
    display: 'flex',
    margin: '1rem 0',
  },
});

const TableReleases = props => {
  const {
    classes,
    payment_account_id,
    params,
    isLoading,
    isRefetching,
    refetch,
    handleChangePage,
    handleChangeRowsPerPage,
    releasesData,
  } = props;

  const [editingId, setEditingId] = useState(null);

  const { data: groups } = useQuery(['groups'], Groups.getAllSegmented);

  const handleEditRow = id => setEditingId(id);
  const { total, results: releases } = releasesData;

  if (isLoading)
    return (
      <MuiTableContainer component={MuiPaper}>
        <MuiCircularProgress />
      </MuiTableContainer>
    );
  return (
    <MuiTableContainer>
      <MuiTypography className={classes.title} variant="h5">
        {`Releases ${payment_account_id ? `For ${payment_account_id}` : ''}`}
      </MuiTypography>

      <MuiTable>
        <MuiTableHead>
          <MuiTableRow>
            <MuiTablePagination
              rowsPerPageOptions={[5, 10, 25]}
              rowsPerPage={params.rows_per_page}
              count={total}
              page={params.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </MuiTableRow>
          <MuiTableRow>
            <MuiTableCell>id</MuiTableCell>
            <MuiTableCell>Group</MuiTableCell>
            <MuiTableCell>Artist Name</MuiTableCell>
            <MuiTableCell>Title</MuiTableCell>
            <MuiTableCell>UPC</MuiTableCell>
            <MuiTableCell>Status</MuiTableCell>
            <MuiTableCell align="right"></MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {releases?.map(release => (
            <Row
              key={release.id}
              editing={editingId === release.id}
              onEditChange={handleEditRow}
              release={release}
              releaseChanged={refetch}
              isRefetching={isRefetching}
              groups={groups}
            />
          ))}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
};

export default withStyles(styles)(withRouter(TableReleases));
